<template>
    <div class="Cyber-page" :style="{overflow: isShowPopup ? 'hidden' : ''}">
        <!-- 返回、标题 -->
        <div
            class="Cyber-page-header"
            :style="{ paddingTop: 25 + statusBarHeight + 'px' }"
        >
            <div class="Cyber-page-header-return" @click="handleClosePage">
                <img
                :src="require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/page_close.png')"
                />
            </div>
            <h1 class="Cyber-page-header-title"></h1>
        </div>
        <!-- 顶部区域 -->
        <div class="Cyber-page-top">
            <img
                :src="require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/index_banner.png')"
            />
        </div>
        <!-- 列表域 -->
        <div 
            class="Cyber-page-list"
            :style="{ 
                // paddingTop: statusBarHeight + 'px'
                marginTop: '18px'
            }"
        >
            <div class="Cyber-page-list-content">
                <!-- 数据列表 -->
                <div class="Cyber-page-list-content-listView">
                    <!-- 单项 -->
                    <div class="Cyber-page-list-content-listView-item" 
                         v-for="(item, index) in listData" 
                         @click="ticketHandle(item)"
                         :key="index">
                         <!-- 票上层 -->
                        <div class="Cyber-page-list-content-listView-item-top">
                            <div class="Cyber-page-list-content-listView-item-top-bg"></div>
                            <img :src="item?.img">
                        </div>
                         <!-- 票下层 -->
                         <div class="Cyber-page-list-content-listView-item-bottom">
                            <span>{{ item?.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 挂载 -->
        <TicketPopup 
            v-show="isShowPopup"
            :ticket="currentTicket"
            @msgHandle="PopupHandle"
        />
    </div>
</template>
  
<script>
import { onBeforeMount, onMounted, ref, getCurrentInstance } from "vue";
import { useRoute } from 'vue-router';
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
// import {getGuideRoleLanguage} from "@/api/language.js";
import _ from "lodash";
import store from "@/store";
import TicketPopup from "./components/TicketPopup";
import { getUnuseTicketList, postMergeTicket, postUseTicket } from "@/api/cyberport.js"
import { ERROR_TEXT } from "@/constants/enums";
import { TOAST_TYPE } from "@/components/Toast/index.vue";

export default {
components: {
    TicketPopup,
},
props: {
    id: {
        type: Number,
        default: 0,
    },
},
computed: {
    ...mapState({
        // init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
    }),
},
setup(props) {
    const {id} = props;
    const { proxy } = getCurrentInstance();
    const route = useRoute();
    const listData = ref([
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/uber.png'),
            name: 'uber - HK$25 off voucher',
            desc: 'Book an uber ride at a discount with your HONG KONG DIRL PASS. Unlock your perk right now!',
            url: 'yuliverse-redeem.domin.foundation/campaigns/uber',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/tripcom.png'),
            name: 'Trip.com - hotel 5% off coupon',
            desc: 'Book an accommodation at a discount for all hotels on Trip.com with your HONG KONG DIRL PASS. Unlock your perk right now!',
            url: 'yuliverse-redeem.domin.foundation/campaigns/tripcom',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/onus.png'),
            name: 'PARKnSHOP / Hung Fook Tong / Pacific Coffee / Wing Wah - HK$50 off voucher',
            desc: `Claim the discounted voucher with your HONG KONG DIRL PASS for brands below: 
                    1.PARKnSHOP
                    2.Hung Fook Tong
                    3.Pacific Coffee
                    4.Wing Wah

                    Please refer to the terms and details on On-us before using the vouchers.`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/onus',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/rosemaese.png'),
            name: 'ROSEMA.ESE - 10% off coupon',
            desc: `Enjoy a promo code of 10% off discount on online shop with your HONG KONG DIRL PASS.`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/rosemaese',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/blazecraft.png'),
            name: 'Blaze Craft - buy one, get one free coupon',
            desc: `Redeem a buy one free one craft beer with your HONG KONG DIRL PASS.`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/blazecraft',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/chillpillhk.png'),
            name: 'Chill Pill HK - free sweet potato fries coupon',
            desc: `Redeem one sweet potato fries with your HONG KONG DIRL PASS!
                    · Minimum order required: at least one drink or dish`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/chillpillhk',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/curatorcreativecafe.png'),
            name: 'CURATOR Creative Cafe at M+ - 10% off coupon',
            desc: `Redeem one 10% off discount with your HONG KONG DIRL PASS.
                    · Minimum order required: at least one drink`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/curatorcreativecafe',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/ellipsiscafelounge.png'),
            name: 'Ellipsis Cafe & Lounge - free shot coupon',
            desc: `Redeem one free shot with your HONG KONG DIRL PASS.
                    · Minimum order required: at least one drink or dish`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/ellipsiscafelounge',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/enso.png'),
            name: 'Enso - buy one, get one free coupon',
            desc: `Redeem a free coupon with your HONG KONG DIRL PASS.`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/enso',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/loungehakuba.png'),
            name: 'Lounge Hakuba - free cocktail coupon',
            desc: `Redeem one free house spirit single mix cocktail with your HONG KONG DIRL PASS!
                    · Minimum order required: at least one drink or dish
                    · After 6pm`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/loungehakuba',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/hoper.png'),
            name: 'Hoper - 50% off coupon for 2nd same item',
            desc: `Redeem a second discounted craft beer with your HONG KONG DIRL PASS! 
                    · The discount is for the 2nd same volume of beer`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/hoper',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/jessecoffeesando.png'),
            name: 'JESSY COFFEE SANDO - 50% off coupon for 1st drink',
            desc: `Redeem a discounted first drink with your HONG KONG DIRL PASS.
                    · Each person can only use the coupon once`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/jessecoffeesando',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/popmazecafe.png'),
            name: 'Popmaze.cafe - buy one, get one free coupon (take out only)',
            desc: `Redeem a buy one free one coffee with your HONG KONG DIRL PASS.
                    · Take out only`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/popmazecafe',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/ohmcafeandbar.png'),
            name: 'ohm... cafe and bar - 50% off for coupon second cocktail',
            desc: `Redeem a second discounted cocktail with your HONG KONG DIRL PASS.`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/ohmcafeandbar',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/thaikau.png'),
            name: 'Thai Kau - free dessert coupon',
            desc: `Redeem one free dessert with your HONG KONG DIRL PASS.
                    · TMinimum order required: HK$300`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/thaikau',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/mozycafebar.png'),
            name: 'MOZY Cafe & Bar - free beer coupon',
            desc: `Redeem one free beer with your HONG KONG DIRL PASS!
                    · Minimum order required: any purchase`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/mozycafebar',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/xia1.png'),
            name: 'XIA - 10% off Main Menu Items coupon',
            desc: `Redeem one 10% off discount with your HONG KONG DIRL PASS.
                    · Minimum order required: HK$300`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/xia1',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/xia2.png'),
            name: 'XIA - 10% off Full Price Merchandise coupon',
            desc: `Redeem one 10% off discount with your HONG KONG DIRL PASS.
                    · Minimum order required: HK$300`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/xia2',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/cview1.png'),
            name: 'CVIEW - 10% off Main Menu items coupon',
            desc: `Redeem one 10% off discount with your HONG KONG DIRL PASS.
                    · Minimum order required: HK$300`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/cview1',
        },
        {
            img: require('@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/iconCp/cview2.png'),
            name: 'CVIEW - Buy 1 Get 1 Free on “Selected Wines” coupon',
            desc: `Redeem a buy one free one selected wine with your HONG KONG DIRL PASS.
                    · Valid time: 4~7pm
                    · Minimum order required: HK$300`,
            url: 'yuliverse-redeem.domin.foundation/campaigns/cview2',
        },
    ])
    const isShowPopup = ref(false);
    const currentTicket = ref(null);

    onMounted(() => {
        appBridging.getStatusBarHeight();
    });

    /**
     * 票点击处理
     */
    const ticketHandle = (ticket) => {
        console.log(ticket);
        currentTicket.value = ticket;
        isShowPopup.value = true;
    }

    /**
     * 关闭页面
     */
     const handleClosePage = () => {
      appBridging.closePage();
    };

    /**核销弹窗监听处理 */
    const PopupHandle = (state) => {
        if(state == false){
            isShowPopup.value = false;
            return;
        }
    }


    return {
        handleClosePage,
        ticketHandle,
        PopupHandle,
        listData,
        currentTicket,
        isShowPopup,
    };
},
};
</script>
  
<style lang="less" scoped>
    .Cyber-page{
        width: 100%;
        height: 100vh;
        background-color: #010000;
        position: relative;
        box-sizing: border-box;
        overflow: scroll;
        &-header {
            position: absolute;
            top: 0;
            width: 100%;
            height: 45px;
            display: flex;
            &-return {
                width: 55px;
                height: 30px;
                text-align: left;
                margin-bottom: 18px;
                img {
                    width: 100%;
                    height: 100%;
                    margin-left: -4px;
                }
            }
            &-title {
                // padding-top: 15px;
                margin-left: calc((100vw / 2) - 64.07px);
                transform: translateX(-50%);
                color: rgba(255, 255, 255, 1);
                font-size: 16px;
                font-weight: 500;
                font-family: "PingFang SC";
                text-align: center;
                line-height: 30px;
            }
        }
        &-top{
            width: 375px;
            height: 379px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-list{
            width: 100%;
            padding: 0 8px;
            box-sizing: border-box;
            &-content{
                width: 100%;
                height: 100%;
                &-listView{
                    width: 100%;
                    box-sizing: border-box;
                    &-item{
                        width: 343px;
                        height: calc(120px + 34px);
                        margin: 0 auto;
                        margin-bottom: 25px;
                        position: relative;
                        &-top{
                            width: 343px;
                            height: 120px;
                            position: relative;
                            img{
                                width: 100px; 
                                height: 100px;
                                position: absolute;
                                top: 10px;
                                right: 10px;
                            }
                            &-bg{
                                position: absolute;
                                z-index: 0;
                                width: 100%;
                                height: 100%;
                                background: url("~@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/item_bg_top.png")
                                no-repeat top left;
                                background-size: 100% 100%;
                            }
                        }
                        &-bottom{
                            position: absolute;
                            z-index: 1;
                            bottom: 10px;
                            width: 100%;
                            height: 34px;
                            box-sizing: border-box;
                            color: #2E2E2E;
                            font-family: "Noto Sans S Chinese";
                            font-size: 14px;
                            font-weight: 500;
                            padding-top: 4px;
                            padding-left: 11px;
                            padding-right: 8px;
                            line-height: 14px;
                            display: flex;
                            align-items: center;
                            text-align: left;
                            background: url("~@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/item_bg_bottom.png")
                            no-repeat top left;
                            background-size: 100% 100%;
                        }
                    }
                }
            }
        }
    }
</style>